import { GetPageByRouteQuery } from "apollo"
import { extractProperty } from "./extractProperty"
import { getNonUmbracoUrl } from "./getNonUmbracoUrl"

type Parent = {
  url: string | null | undefined
  id: number | null | undefined
  level: number | null | undefined
  parent: Parent
}

export type Breadcrumbs = {
  url: string
  title: string
  isPage?: boolean
}[]

function extractTitle(data: any) {
  const pageBlock = extractProperty(data, "pageInfoAndMetaTags")
  if (pageBlock) {
    data = pageBlock?.[0]
  }
  const title = extractProperty(data, "titleBreadcrumbs") as string | undefined
  return title
}

function hasPageContent(data: any): boolean {
  const hasBlocks = !!extractProperty(data, "blocks")?.length
  const hasPageHeader = !!extractProperty(data, "pageHeader")?.length
  const hasPageContent = !!extractProperty(data, "pageContent")?.length
  const hasPageInfoAndMetaTags = !!extractProperty(data, "pageInfoAndMetaTags")
    ?.length

  return hasBlocks || hasPageHeader || hasPageContent || hasPageInfoAndMetaTags
}

export function getBreadCrumbs(data: GetPageByRouteQuery, locale: string) {
  const self = extractTitle(data.page)
  const selfObject: { url: string; title: string } = {
    title: self || "",
    url: getNonUmbracoUrl(data.page?.url || ""),
  }
  const parent = data.page?.parent as Parent
  const parents: Array<{ url: string; title: string; clickable?: boolean }> = []
  function recurse(currentParent: Parent | null) {
    if (
      currentParent &&
      currentParent.level !== null &&
      currentParent.level !== undefined &&
      currentParent.level >= 3
    ) {
      const parentTitle = extractTitle(currentParent)
      const parentUrl = getNonUmbracoUrl(currentParent.url || "")
      if (parentTitle) {
        // Check if the parent has actual content
        const isPage = hasPageContent(currentParent)

        parents.push({
          url: parentUrl,
          title: parentTitle,
          clickable: isPage,
        })
      }
      if (currentParent.parent) {
        recurse(currentParent.parent)
      }
    }
  }
  recurse(parent ?? null)
  return {
    selfObject,
    parents: [
      {
        title:
          {
            he: "ראשי",
            ar: "الرئيسية",
            ru: "Главная",
            en: "Home page",
          }[locale] || "ראשי",
        url:
          {
            he: "/",
            ar: "/",
            ru: "/",
            en: "/",
          }[locale] || "/",
        clickable: true, // Home page is always clickable
      },
      ...parents.reverse(),
    ],
  }
}

export type BreadCrumbs = {
  selfObject: { url: string; title: string }
  parents: Array<{ url: string; title: string; clickable?: boolean }>
}
